import {ActiveInfoPageConfig} from '@/components/Ui/ActiveInfoPage/BZCore/ActiveInfoPage'

import pollStatus from '@/components/polls/page/blocks/status.vue'
import pollDownload from '@/components/polls/page/blocks/download.vue'
import pollStatistic from '@/components/polls/page/blocks/statistic.vue'
import pollSystemInfo from '@/components/polls/page/blocks/systemInfo.vue'
import pollName from '@/components/polls/page/blocks/name.vue'
import pollResult from '@/components/polls/page/blocks/result.vue'


const config: ActiveInfoPageConfig = {
  mapsColumns: {
    lg: [['status', 'download', 'statistic', 'systemInfo'], ['name', 'result']],
    xs: [['name', 'result', 'status', 'download', 'statistic', 'systemInfo']]
  },
  blocks: {
    status: {
      block: pollStatus,
      options: {}
    },
    download: {
      block: pollDownload,
      options: {}
    },
    statistic: {
      block: pollStatistic,
      options: {}
    },
    systemInfo: {
      block: pollSystemInfo,
      options: {}
    },
    name: {
      block: pollName,
      options: {}
    },
    result: {
      block: pollResult,
      options: {}
    },
  }
}
export default config